import { render, staticRenderFns } from "./UsersVacationsStatistic.vue?vue&type=template&id=c76e051c&"
import script from "./UsersVacationsStatistic.vue?vue&type=script&lang=js&"
export * from "./UsersVacationsStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports